import component from 'src/products/core-prospect/search-pages/components/Sidebar/Views/FiltersView/CoreProspectFilters/MultipleSelection/component';
import serializer from 'src/components/filters/MultipleSelection/serializer';

export default {
  component,
  serializer,
};
